export default "__VITE_ASSET__cdf9f029__"